module.exports = __webpack_public_path__ + "static/media/basel-28.1af4bc46.jpg";